import { render, staticRenderFns } from "./LicenseStatusChip.vue?vue&type=template&id=e36e45aa"
import script from "./LicenseStatusChip.vue?vue&type=script&lang=js"
export * from "./LicenseStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports